<mat-slide-toggle
  data-at-toggle-remote-diagnostics-toggle-boolean-choice
  gtm="onToggle"
  gtmAction="Toggle boolean choice vdd"
  gtmCategory="diagnosticsPage"
  [disabled]="!isVddEditable"
  [checked]="matchedValue.value === matchedValue.structure[1].texttableentry"
  (change)="onToggleChange($event)"
  >{{ matchedValue.value }}</mat-slide-toggle
>
